import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private messageSource = new BehaviorSubject('default message');
  private membershipSource = new BehaviorSubject('default message');
  private userRoleSource = new BehaviorSubject('default message');
  private bpgListSource = new BehaviorSubject('default message');
  private eventsViewDetailsSource = new BehaviorSubject('default message');
  // private eventEditDataSource = new BehaviorSubject(null);
  private expenseEditDataSource = new BehaviorSubject(null);
  private navigationBpgListSource = new BehaviorSubject('default message');
  private claimExpense = new BehaviorSubject(null);
  private siteIdAndPathSource = new BehaviorSubject('default message');
  private eventDateSource = new BehaviorSubject('null');
  private selectedEventDataSourceSource = new BehaviorSubject('null');
  //private siteIdBpgIdAndPathSource = new BehaviorSubject('default message');
  private messageApproveSource = new BehaviorSubject('default message');
  private budgetDateSource = new BehaviorSubject(null);
  private selectedMyBpgsDataSource = new BehaviorSubject('default message');
  private selectedSiteIdSource = new BehaviorSubject('default message');
  private selectedSiteIdForSiteMenuSource = new BehaviorSubject('default message');
  private selectedNaacIdForNaacMenuSource = new BehaviorSubject('default message');
  private folderSectionSource = new BehaviorSubject('null');
  private  isEventPopupOpenedSource = new BehaviorSubject(null); 
  private setBannerSource = new BehaviorSubject(null); 
  savedMembershipForm = this.membershipSource.asObservable();
  savedData = this.messageSource.asObservable();
  userRoleData = this.userRoleSource.asObservable();
  bpgListData = this.bpgListSource.asObservable();
  selectedEventsDetails = this.eventsViewDetailsSource.asObservable();
  selectedBpgList = this.navigationBpgListSource.asObservable();
  //eventEditData = this.eventEditDataSource.asObservable();
  expenseEditData = this.expenseEditDataSource.asObservable();
  claimExpenseData = this.claimExpense.asObservable();
  siteIdAndPath = this.siteIdAndPathSource.asObservable();
  eventDate = this.eventDateSource.asObservable();
  //siteIdBpgIdAndPath = this.siteIdBpgIdAndPathSource.asObservable();
  eventViewApprove = this.messageApproveSource.asObservable();
  claimExpenseApprove = this.messageApproveSource.asObservable();
  eventData = this.selectedEventDataSourceSource.asObservable();
  budgetData = this.budgetDateSource.asObservable();
  myBpgsData = this.selectedMyBpgsDataSource.asObservable();
  selectedSiteId = this.selectedSiteIdSource.asObservable();
  selectedSiteIdForSiteNavMenu = this.selectedSiteIdForSiteMenuSource.asObservable();
  selectedNaacIdForNaacMenu = this.selectedNaacIdForNaacMenuSource.asObservable();
  folderSection = this.folderSectionSource.asObservable();
  isEventPopupOpened = this.isEventPopupOpenedSource.asObservable();
  isBanner = this.setBannerSource.asObservable();

  
  constructor() { }

  saveData(message: any) {
    this.messageSource.next(message)
  }

  userRoleDetails(message: any) {
    this.userRoleSource.next(message)
  }
  bpgList(message: any) {
    this.bpgListSource.next(message);
  }
  showSavedMembershipForm(message: any) {
    this.membershipSource.next(message)
  }
  getSelectedEventDetails(message: any) {
    console.log(message);
    this.eventsViewDetailsSource.next(message);
  }
  // setEditEventData(message: any) {
  //   this.eventEditDataSource.next(message);
  // }
  selectedNavigationBpgs(message: any) {
    console.log(message);
    this.navigationBpgListSource.next(message);
  }
  selectedSiteIdAndPath(message: any) {
    this.siteIdAndPathSource.next(message);
  }
  // selectedSiteIdBpgIdAndPath(message: any) {
  //   this.siteIdBpgIdAndPathSource.next(message);
  // }
  setSelectedEventDate(message: any) {
    this.eventDateSource.next(message);
  }
  setselectedEventInfo(message: any) {
    this.selectedEventDataSourceSource.next(message);
  }
  // selectedSiteIdBpgIdAndPath(message:any){
  //   this.siteIdBpgIdAndPathSource.next(message);

  // }
  saveClaimData(data: any) {
    this.claimExpense.next(data);
  }

  setApproved(message: any) {
    this.messageApproveSource.next(message);
  }

  setEditExpenceData(message: any) {
    this.expenseEditDataSource.next(message);
  }

  saveBudget(message: any) {
    this.budgetDateSource.next(message);
  }
  setMyBpgSiteIdAndBpgId(message: any) {
    this.selectedMyBpgsDataSource.next(message);
  }
  setSiteId(message: any) {
    this.selectedSiteIdSource.next(message);
  }
  selectedSiteIdForSiteMenu(message: any) {
    this.selectedSiteIdForSiteMenuSource.next(message);

  }
  selectednaacIdForNaacMenu(message: any) {
    this.selectedNaacIdForNaacMenuSource.next(message);

  }
  folderSections(message: any) {
    this.folderSectionSource.next(message);

  }
  setEventPopupOpened(message: any)
  {
    this.isEventPopupOpenedSource.next(message);

  }
  setBanner(message: any)
    {
      this.setBannerSource.next(message)
    }
}

export class bpgs {
  bpgId: number;
  name: string;
  desc: string;
}

export class interests {
  areaOfImpactId: number;
  subcategory: string;
}

export class skills {
  skillId: number;
  skill_name: string;
  skill_desc: string;
}

export class leadership {
  chair: boolean;
  viceChair: boolean;
  communicationsChair: boolean;
  financeChair: boolean;
}

export class demographics {
  demograhicId: number;
  demographics_name: string;
}

export class site {
  siteId: number;
  siteName: string;
  siteDesc: string;
}

export class membershipFormData {
  virtualBpg: boolean;
  siteFormData: site;
  bpgFormData: bpgs[];
  interestFormData: interests[];
  skillsFormData: skills[];
  leadershipFormData: leadership;
  //demographicsFormData:demographics[]; //demographic code commented
  otherSkillsFormData: string;

}

export class membershipDetails {
  bpgIds: any[] = [];
  skillIds: any[] = [];
  areaOfImpactIds: any[] = [];
  demographicIds: any[] = [];
  otherSkills: string;
  leadershipDetails: leadership;

}

export class membershipData {
  bpgIds: any[] = [];
  skillIds: any[] = [];
  areaOfImpactIds: any[] = [];
  demographicIds: any[] = [];
  otherSkills: string;
  leadershipDetails: leadership;
}


export class LandingDTOModel {
  filter: FilterModel;
  moduleId: number;
  page: number = 0;
  presentRole: string = '-';
  searchTerm: string = '';
  size: number = 0;
  sortDirection: string = 'ASC';
  sortProperty: string = '-';
  uid: string = '-';
  expenseId?: number;
  leadAdminApprovedBy?: number;
  leadAdminApprovalComment?: string;
  superAdminApprovedBy?: number;
  superAdminApprovalComment?: string;
  expenseStatus?: string;
}

export class FilterModel {
  userId?: string;
  siteId?: string;
  fromDate?: string;
  toDate?: string;
  bpgId?: string;
  chapterId?: string;
  adminId?: string;
  eventId?: string;
  hoshinId?: string;
}

export class Budget {
  budgetId?: number;
  chapterId?: number;
  fiscalYear?: string;
  affinityGoals?: string = "";
  chapterGoals?: string = "";
  chapterName?: string = "";
  siteName?: string = "";
  budgetStatus?: string = "";
  budgetAllocatedDate?: Date = null;
  budgetAllocatedBy?: string = "";
  comment?: string = "";
  budgetSource?: string = "";
  requestedBudgetAmount?: number;
  approvedBudgetAmount?: number;
  budgetRequestedBy?: number;
  budgetRequestedDate?: Date = null;
}
export class Amount{
  requestedAmount? : number;
  approvedAmount? : number;
  
  }
export class Hoshin {
  hoshinId?: number;
  chapterId?: number;
  fiscalYear?: any;
  bpgInitiative?: string = "";
  businessDrivers?: string = "";
  actionPlan?: string = "";
  kpi?: string = "";
  estimatedTiming?: string = "";
  proposedBudget?: number;
  leadApprovedBudget?: number;
  superAdminApprovedBudget?: number;
  midYearResults?: string = "";
  yearEndResults?: string = "";
  challenges?: string = "";
  hoshinPlanBy?: number;
  supportingDoc1?: string = "";
  isLeadApproved?: boolean;
  leadAdminApprovedBy?: number;
  leadAdminApprovalComment?: string = "";
  isSuperAdminApproved?: boolean;
  superAdminApprovedBy?: number;
  superAdminApprovalComment?: string = "";
  hoshinSubmitDate?: Date = null;
  leadAdminApprovedDate?: Date = null;
  superAdminApprovedDate?: Date = null;
  name?: string = "";
  budgetType?: string = "";
  createdBy?: string = "";
  modifiedBy?: string = "";
  isActive?: boolean;
  actionPlaceholder?: string;
  kpiPlaceholder?: string;
  status?: string = "";
  frequency?: string = "";
  leadId1?: number;
  leadId2?: number;
  lead1Name?: String = "";
  lead2Name?: String = "";
  baseHoshinExists?: String = "";
  additionalFunding?: String = "";
  additionalFundingSource?: String = "";
  evaluation?: String = "";
}

export class BudgetHoshin {
  budgetMasterDTO: Budget;
  hoshinMasterDTOList: Hoshin[];
  deleteHoshinIds: Array<number>;
  hoshinSave?: boolean;
}

/* Survey Response */
export class Employee {
  userId: any;
}
export class SurveyQuestion {
  surveyQuestionId: any;
}
export class SurveyAnswer {
  answerId: any;
}
export class TakeSurvey {
  comments: string = "";
  modifiedBy?: string = "";
  createdBy?: string = "";
  employee: Employee;
  surveyAnswer: SurveyAnswer;
  surveyQuestion: SurveyQuestion;
  surveyResponseId: any;
  surveyId: any;
  surveyTakenUserName: string = "";
}

export class SurveyMaster {
  surveyId: number;
  eventId: number;
  surveryDesc?: string = "";
  surveyLaunchAdmin: number;
  startDate?: Date = new Date();
  endDate?: Date = new Date();
}

export class SitePrimaryContactDTO {
  createdBy: string = "";
  createdDateTime: Date = null;
  isActive: boolean;
  siteId: number;
  sitePrimaryContactId: number = null;
  userId: number;
}

export class SuveyTakenByUserDTO {
  surveyId: number;
  userId: number;
}

/*Pagination DTO */
export class LandingPaginationDTO {
  filter: {};
  moduleId: number = 0;
  page: number = 0;
  presentRole: string = '';
  searchTerm: string = '';
  size: number = 0;
  sortDirection: string = '';
  sortProperty: string = '';
  uid: string = '';
}

